<template>
  <div class="page">
    <van-nav-bar title="团队提交监控" left-arrow @click-left="$router.back()"/>
    <section class="month">
      <button aria-label="上个月" @click="change(-1)">
        <van-icon name="arrow-left"/>
      </button>
      <b>{{ month.replace('-', ' 年 ') }} 月</b>
      <button aria-label="下个月" @click="change(1)">
        <van-icon name="arrow"/>
      </button>
    </section>
    <van-skeleton v-if="loading" title :row="8"/>
    <template v-else>
      <section class="summary">
        <div><span>团队提交率</span><b>{{ data.submissionRate || 0 }}%</b></div>
        <div><span>实交 / 应交</span><b>{{ data.submitted || 0 }}/{{ data.expected || 0 }}</b></div>
        <div><span>待复核</span><b>{{ data.pendingReview || 0 }}</b></div>
      </section>
      <main>
        <header><h2>成员明细</h2><span>{{ (data.employees || []).length }} 人</span></header>
        <article v-for="item in data.employees || []" :key="item.employeeId">
          <div class="avatar">{{ item.employeeName.slice(-1) }}</div>
          <div class="copy"><b>{{ item.employeeName }}</b><span>{{ item.positionName }}</span></div>
          <p><strong>{{ item.submittedDays }}/{{ item.expectedDays }}</strong><em
            :class="{missing:item.missingDays}">{{ item.missingDays ? `缺交 ${item.missingDays} 天` : '已完成' }}</em></p>
        </article>
        <van-empty v-if="!(data.employees || []).length" description="暂无团队成员"/>
      </main>
    </template>
  </div>
</template>

<script>
/**
 * 主管团队提交监控：按月查看提交率与各成员缺交天数。
 */
import coreapi from '@/utils/coreapi';

export default {
  data() {
    const d = new Date();
    return {month: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, data: {}, loading: false};
  },
  mounted() {
    this.load();
  },
  activated() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.data = await coreapi.supervisorMonitor(this.month);
      } catch (e) {
        this.$toast.fail(e.message);
      } finally {
        this.loading = false;
      }
    },
    change(offset) {
      const parts = this.month.split('-');
      const d = new Date(+parts[0], +parts[1] - 1 + offset, 1);
      this.month = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      this.load();
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/base.less";
@import "./supervisor.less";

.page {
  min-height: 100vh;
  padding-bottom: .4rem;
  background: #f6f7fb;
  color: #333;
  letter-spacing: 0
}

.month {
  height: .94rem;
  padding: 0 .3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff
}

.month button {
  width: .68rem;
  height: .68rem;
  color: #73768a;
  font-size: .3rem
}

.month b {
  color: #34364a;
  font-size: .31rem
}

.summary {
  padding: .28rem;
  display: grid;
  grid-template-columns:repeat(3, minmax(0, 1fr));
  gap: .14rem
}

.summary div {
  position: relative;
  min-height: 1.32rem;
  padding: .22rem .2rem;
  overflow: hidden;
  background: #fff;
  border-radius: .2rem;
  box-shadow: 0 .06rem .24rem rgba(211, 47, 47, .09);
  box-sizing: border-box
}

.summary div:before {
  content: "";
  position: absolute;
  left: 0;
  top: .22rem;
  width: .06rem;
  height: .44rem;
  border-radius: 0 .05rem .05rem 0;
  background: @color
}

.summary div:nth-child(2):before {
  background: #35a56f
}

.summary div:nth-child(3):before {
  background: #D32F2F
}

.summary span, .summary b {
  display: block
}

.summary span {
  color: #8a8da3;
  font-size: .22rem;
  white-space: nowrap
}

.summary b {
  margin-top: .1rem;
  color: #34364a;
  font-size: .36rem
}

main {
  margin: 0 .28rem;
  padding: .3rem;
  background: #fff;
  border-radius: .24rem;
  box-shadow: 0 .08rem .3rem rgba(211, 47, 47, .1)
}

main > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: .12rem
}

h2 {
  font-size: .34rem
}

main > header span {
  color: #9295a7;
  font-size: .24rem
}

article {
  padding: .24rem 0;
  display: flex;
  align-items: center;
  border-bottom: 1PX solid #eee
}

.avatar {
  flex: 0 0 .72rem;
  width: .72rem;
  height: .72rem;
  line-height: .72rem;
  margin-right: .18rem;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  background: @color;
  font-size: .26rem;
  white-space: nowrap;
  overflow: hidden
}

.copy {
  min-width: 0;
  flex: 1
}

.copy b, .copy span, article strong, article em {
  display: block
}

.copy b {
  color: #34364a;
  font-size: .3rem
}

.copy span {
  margin-top: .04rem;
  color: #999;
  font-size: .24rem
}

article p {
  text-align: right
}

article strong {
  color: #34364a;
  font-size: .3rem
}

article em {
  margin-top: .04rem;
  color: #298758;
  font-size: .23rem;
  font-style: normal
}

article em.missing {
  color: #d54c4c
}
</style>



// WEBPACK FOOTER //
// src/views/efficiency/supervisor/Monitor.vue